
// Rollobst Positioning based on scroll
ready(function() {
    const rollobstElements = findAll('.rollobst');
    const viewportHeight = window.innerHeight;

    // add class "visible" to all rollobst elements on load
    rollobstElements.forEach(function(element) {
        element.classList.add('visible');
    });

    // update positions of all rollobst elements
    function updatePositions() {
        rollobstElements.forEach(function(element) {

            // Get the parent element for stable position calculation
            const rect = element.getBoundingClientRect();
            const elementTop = rect.top;
            const elementHeight = rect.height;

            let position;

            // Use viewport-based trigger zone with 50px padding
            const padding = 50;
            const triggerStart = viewportHeight + padding + (elementHeight * 0.5); // Start when element is below viewport + padding
            const triggerEnd = -padding - (elementHeight * 0.5); // End when element is above viewport + padding

            if (elementTop >= triggerStart) {
                position = 1;
            } else if (elementTop <= triggerEnd) {
                position = 0;
            } else {
                // Linear interpolation between start and end
                const progress = (elementTop - triggerEnd) / (triggerStart - triggerEnd);
                position = Math.max(0, Math.min(1, progress));
            }

            // Set the position variable on the inner element
            element.style.setProperty('--position', position);
        });
    }

    // Initial update
    updatePositions();

    // Update on scroll
    window.addEventListener('scroll', updatePositions, { passive: true });

    // Also update on resize
    window.addEventListener('resize', updatePositions, { passive: true });
});